export const FORM_FIELD_KEY = {
  NAME: 'customerName',
  EMAIL: 'customerEmail',
  PHONE: 'customerPhone',
  NOTE: 'customerNote',
}
